import { render, staticRenderFns } from "./Quicklinks.vue?vue&type=template&id=61878b8b&scoped=true"
import script from "./Quicklinks.vue?vue&type=script&lang=js"
export * from "./Quicklinks.vue?vue&type=script&lang=js"
import style0 from "./Quicklinks.vue?vue&type=style&index=0&id=61878b8b&lang=css"
import style1 from "./Quicklinks.vue?vue&type=style&index=1&id=61878b8b&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61878b8b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('61878b8b')) {
      api.createRecord('61878b8b', component.options)
    } else {
      api.reload('61878b8b', component.options)
    }
    module.hot.accept("./Quicklinks.vue?vue&type=template&id=61878b8b&scoped=true", function () {
      api.rerender('61878b8b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/app/dashboard/footer-pages/components/Quicklinks.vue"
export default component.exports